<template>
  <v-container grid-list-xl class="pa-0">
    <v-layout wrap>
      <v-flex xs12>
        <m-card-list
          two-line
          title="Monitoring Aktivasi Layanan"
          label-cari="Cari Monitoring"
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="
            search => {
              textSearch = search;
              load();
            }
          "
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
        >
          <template v-slot:items="{ props, item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>{{ pVal(item, "nama") }}</td>
              <td>
                <p class="my-0 py-0">{{ pVal(item.users, "nama") }}</p>
                <p class="blue--text text--darken-4">{{pVal(item.users,'email')}}</p>
              </td>
              <td>{{ pVal(item, "token") }}</td>
              <td>
                <v-chip
                  label
                  outlined
                  dark
                  :color="item.k_status.id==1?'green':'red'"
                >{{pVal(item.k_status,'keterangan')}}</v-chip>
              </td>
              <td>
                <v-btn color="deep-orange lighten-1 white--text" small>
                  <v-icon color="white">mdi-pdf-file</v-icon>Cetak
                </v-btn>
              </td>
              <!-- <td>
                <m-menu left style="float:right" :items="more_menu" :object="item" />
              </td>-->
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[0].text }}</div>
                <div class="v-data-table__mobile-row__cell">{{ pVal(item.instansi, "nama") }}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[2].text }}</div>
                <div class="v-data-table__mobile-row__cell">
                  <m-menu left style="float:right" :items="more_menu" :object="item" />
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Instansi", align: "left", value: "nama" },
        { text: "Admin Instansi", align: "left", value: "nama" },
        { text: "Token", align: "left", value: "value" },
        { text: "Status", align: "left", value: "value" },
        { text: "Cetak", align: "left", value: "value" }
        // { text: "", sortable: false }
      ],
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan("monitoring.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan("monitoring.destroy")
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("monitoring/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          // this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1">
            Data Atribut ${item.nama} yang telah di masukkan ke data user juga akan dihapus oleh sistem
          </div>
        </div>


        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.nama}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch("monitoring/drop", item.aktivasi_id))
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
